import { Injectable } from '@angular/core';
import { HttpUtilService } from './http-util.service';
import { of } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(private httpUtils: HttpUtilService) { }
  /** Default configuration for Canvas integration*/
  private lmsCanvasTemplate = {
    'friendly_name': '',
    'lms_type': 'canvas',
    'url': '',
    'access_token': '',
    'access_token2': '',
    'access_token3': '',
    'access_token4': '',
    'access_token5': '',
    'sub_account_id': '',
    'useInlineStyles': false,
    'utilUsername': '',
    'utilPassword': '',
    'patterns': []
  };
/** Default configuration for Blackboard integration*/
  private lmsBlackboardTemplate = {
    'friendly_name': '',
    'lms_type': 'blackboard',
    'url': '',
    'key': '',
    'secret': '',
    'utilUsername': '',
    'utilPassword': '',
    'patterns': [],
    'excludedTitles':[]
  };
/** Default configuration for Sakai integration*/
  private lmsSakaiTemplate = {
    'friendly_name': '',
    'lms_type': 'sakai',
    'url': '',
    'username': '',
    'password': '',
    'patterns': []
  };
/** Default configuration for Moodle integration*/
  private lmsMoodleTemplate = {
    'friendly_name': '',
    'lms_type': 'moodle',
    'url': '',
    'access_token': '',
    'username': '',
    'password': '',
    'patterns': []
  };
/** Default configuration for BrightSpace integration*/
  private brightSpaceTemplate = {
    'friendly_name': '',
    'lms_type': 'brightspace',
    'url': '',
    'appId': '',
    'appKey': '',
    'userId': '',
    'userKey': '',
    'utilUsername': '',
    'utilPassword': ''
  };
/** Default configuration for Jenzabar integration */
  private lmsJenzabarTemplate = {
    'friendly_name': '',
    'lms_type': 'jenzabar',
    'url': '',
    'utilUsername': '',
    'utilPassword': '',
    'patterns': []
  };
  /** Default configuration for Schoology integration */
  private lmsSchoologyTemplate = {
    'friendly_name': '',
    'lms_type': 'schoology',
    'url': '',
    'utilUsername': '',
    'utilPassword': '',
    'patterns': []
  };

  /**
   * Get a list of integrations
   * @param type Type of integrations to get
   * @param name Name of specific integration to get
   * @param jsonData Include details about integrations
   * @param partnerId Instance ID to get, use for getting a list of child instance integrations
   */
  getIntegrations(type = null, name = null, jsonData = false, partnerId = null) {
    let url = environment.apiRoot + '/integrations';
    if (type) {
      url += '/' + type;
      if (name) {
        url += '/' + name;
      }
    }
    if (jsonData) {
      url += '?read=json_data&key_values=created';
    }
    if (partnerId != null) {
      const paramVar = jsonData ? '&' : '?';
      url += `${paramVar}partnerId=${partnerId}`;
    }
    return this.httpUtils.authGet(url);
  }
  /**
   * Create a new integration
   * @param type Type of integration
   * @param name name of integration
   * @param data Settings for the integration
   * @param partnerId Instance id to create the integration in
   */
  createIntegration(type, name, data, partnerId = null) {
    let integrationUrl = `${environment.apiRoot}/integrations/${type}/${name}`;

    if (partnerId != null) {
      integrationUrl += `?partnerId=${partnerId}`;
    }
    return this.httpUtils.request('POST', integrationUrl, { json_data: data }, null, true);
  }
/**
 * Update an integration
 * @param type Type of integration
 * @param name name of integration
 * @param updatedData Settings for the integration
 * @param partnerId Instance id to create the integration in
 */
  updateIntegration(type, name, updatedData, partnerId = null) {
    let integrationUrl = `${environment.apiRoot}/integrations/${type}/${name}`;

    if (partnerId != null) {
      integrationUrl += `?partnerId=${partnerId}`;
    }
    return this.httpUtils.request('PUT', integrationUrl, { json_data: updatedData }, null, true);
  }
  /**
   * Get the default settings for an integration
   * @param name Type of integration
   */
  getTemplate(name) {
    switch (name) {
      case 'canvas':
        return this.lmsCanvasTemplate;
        break;
      case 'blackboard':
        return this.lmsBlackboardTemplate;
        break;
      case 'sakai':
        return this.lmsSakaiTemplate;
        break;
      case 'moodle':
        return this.lmsMoodleTemplate;
        break;
      case 'brightspace':
        return this.brightSpaceTemplate;
        break;
      case 'jenzabar':
        return this.lmsJenzabarTemplate;
        break;
      case 'schoology':
        return this.lmsSchoologyTemplate;
      default:
        break;
    }
  }
}
